export const nzOccupationOptions = [
  { label: "Accountant/Fin. Analyst", value: "ACCOUNTANT" },
  { label: "Administration", value: "ADMINISTRATOR" },
  { label: "Assistant", value: "ASSISTANT" },
  { label: "Benefit", value: "BENEFIT" },
  { label: "Cleaner", value: "CLEANER" },
  { label: "Clerical Worker", value: "CLEANER_WORKER" },
  { label: "Courier Driver", value: "COURIER_DRIVER" },
  { label: "Engineer", value: "ENGINEER" },
  { label: "Factory Hand", value: "FACTORY_HAND" },
  { label: "Government/Defence", value: "GOVERNMENT" },
  { label: "Home Duties", value: "HOME_DUTIES" },
  { label: "Hospitality", value: "HOSPITALITY" },
  { label: "IT", value: "IT" },
  { label: "Labourer", value: "LABOURER" },
  { label: "Legal", value: "LEGAL" },
  { label: "Machine Driver/Operator", value: "MACHINE_DRIVER" },
  { label: "Manager", value: "MANAGER" },
  { label: "Professional", value: "PROFESSIONAL" },
  { label: "Qualified Tradesperson", value: "QUALIFIED_TRADESPERSON" },
  { label: "Retail", value: "RETAIL" },
  { label: "Retired", value: "RETIRED" },
  { label: "Sales Assistant", value: "SALES_ASSISTANT" },
  { label: "Sales Representative", value: "SALES_REPRESENTATIVE" },
  { label: "Self Employed", value: "SELF_EMPLOYED" },
  { label: "Store Person", value: "STORE_PERSON" },
  { label: "Student", value: "STUDENT" },
  { label: "Teacher", value: "TEACHER" },
  { label: "Technician", value: "TECHNICIAN" },
  { label: "Unemployed", value: "UNEMPLOYED" },
] as const;
